export default __webpack_public_path__ + "static/media/ab-img.6ce7717b.webp";